module.exports = __webpack_public_path__ + "static/media/roostyicon.3721ad5d.png";